<div class="modal-content bg-white" style="height: 100vh !important; overflow-y: auto !important;">
  <div class="ps-5 pe-5">
    <!-- Header Start -->
    <div class="modal-header border-0 position-relative">
      <h5 class="modal-title w-100 border-0 mt-5 fw-semibold" style="font-size: 20px" id="myModalLabel">
        {{heading}}
      </h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="onCancelClick()"></button>
    </div>
    <!-- Header ENDS -->
    <!-- Body Start -->
    <div class="modal-body pb-0 ">
      @if (!jsonTemplates || jsonTemplates.length==0 && isApiCompleted) {
        <div>
          <ng-container *ngTemplateOutlet="tempDefaultTemplate"></ng-container>
        </div>
      }

      @if (jsonTemplates && jsonTemplates.length>0 && isApiCompleted) {
        <div class="row">
          <div class="col-12 col-lg-6">
            <!--<input type="text" name="txtTest" [(ngModel)]="entervalue" (change)="changeTest()" />-->
            <h5 class="pt-3 pb-2 body1 headergrey fw-semibold">{{measureText}}</h5>
            <ng-container *ngTemplateOutlet="tempManual"></ng-container>
          </div>
          @if (hasValidImagePath()) {
            <div class="col-12 col-lg-6">
              <!--<ng-container *ngTemplateOutlet="tempImages"></ng-container>-->
              <div class="row">
                @for (element of jsonTemplates; track element; let idx = $index) {
                  @if (!element.isDescriptiveImg) {
                    <div [ngClass]="element.cssClass" (mouseenter)="onImageSelect(element,idx)" (click)="onImageClick(element,idx)">
                      @if (idx == selectedImageIndex) {
                        <div id="divFullScreenIcon">
                          <!--<i class="fa fa-expand" aria-hidden="true" (click)="openImagePopup(element)"></i>-->
                          <div (click)="openImagePopup(element)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-fullscreen" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z"></path>
                            </svg>
                          </div>
                        </div>
                      }
                      <img [ngClass]="idx == selectedIndex && jsonTemplates.length==4?'img-active':''" id="img{{idx}}" [src]="swatchesImagesPath + element.imagePath + element.imageName" class="img-fluid h-100 w-100" style="object-fit:cover" (error)="onImgError($event)" />
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      }
    </div>


    <ng-template #tempManual>
      @if (selectedImage) {
        <div class="discription" [innerHtml]="selectedImage.descriptionHtml">
        </div>
      }


      <!--<a class="text-edgeblue text-underline" (click)="onMoreInfo_Click()" routerLink="#!" [ngClass]="{'disabled grey-muted': !isLoggedIn}">
      <i class="fas fa-external-link-alt"></i> {{moreInfo}}
    </a>-->

    <div class="moreInfoImage pt-3">
      <a class="text-edgeblue text-underline" (click)="onMoreInfo_Click()">
        @if (version == 3.0) {
          <img [src]="imgPathV3 + imgFileName" alt="more-info">
        }
        @if (version != 3.0) {
          <img [src]="imgPath + imgFileName" alt="more-info">
        }
      </a>
    </div>

    @if (hasValidImagePath()) {
      <div class="image pt-3">
        @for (element of jsonTemplates; track element; let idx = $index) {
          @if (element.isDescriptiveImg === true) {
            <div>
              <img [ngClass]="idx == selectedIndex && jsonTemplates.length==4?'img-active':''" id="img{{idx}}" [src]="swatchesImagesPath + element.imagePath + element.imageName" class="img-fluid h-100 w-100" style="object-fit:cover">
            </div>
          }
        }
      </div>
    }
  </ng-template>


  <ng-template #tempDefaultTemplate>
    <!-- Body Start -->
    <h5 class="pt-3 pb-2 body1 headergrey fw-semibold">{{measureText}}</h5>
    <p class="body2 text-black-opacity-point6" [innerHtml]="meaureDescription"></p>
    @if (materialDescriptions.length > 0) {
      <div>
        <strong>{{materialDescriptions[0]}}</strong>
        <div class="pt-3 text-italic">
          <p>{{materialDescriptions[1]}}</p>
          <p>{{materialDescriptions[2]}}</p>
          <p>{{materialDescriptions[3]}}</p>
        </div>
      </div>
    }
    <p class="py-4">
      @if (version != 3.0) {
        <a class="text-edgeblue text-underline" (click)="onMoreInfo_Click()" [ngClass]="{'disabled grey-muted': !isLoggedIn}">
          <i class="fas fa-external-link-alt"></i> {{moreInfo}}
        </a>
      }
    </p>
    <div class="moreInfoImage">
      <a class="text-edgeblue text-underline" (click)="onMoreInfo_Click()">
        @if (version == 3.0) {
          <img [src]="imgPathV3 + imgFileName" alt="more-info">
        }
        @if (version != 3.0) {
          <img [src]="imgPath + imgFileName" alt="more-info">
        }
      </a>
    </div>

  </ng-template>
</div>
</div>